import { Component, OnInit } from '@angular/core'
import { MatProgressBar } from '@angular/material/progress-bar'
import { TableListComponent } from '../../shared/components/table-list/table-list.component'
import { AuthService } from '../../core/services/auth/auth.service'
import { MatDialog } from '@angular/material/dialog'
import {
  PagedContactTypeResponse,
  SearchContactTypeModel,
} from '../../core/models/contact-type.model'
import { FormSearchComponent } from '../../shared/components/form-search/form-search.component'
import { MatPaginatorModule } from '@angular/material/paginator'
import { PageEvent } from '@angular/material/paginator'
import {MatCard} from '@angular/material/card';
import {ClassificationCreateComponent} from '../../features/classification/classification-create/classification-create-component';
import {SnackbarCustomService} from '../../shared/components/snackbar/snackbar-custom.service';
import {MatButton} from '@angular/material/button';
import {HealthAgentCreateComponent} from '../../features/health-agent/doctor-create/health-agent-create.component';
import {ContentSugestionService} from '../../core/services/content-sugestion/message/content-sugestion.service';
import {
  ContentSugestionCreateComponent
} from '../../features/content-sugestion/message-create/content-sugestion-create.component';
import {
  ContentSugestionEditComponent
} from '../../features/content-sugestion/message-edit/content-sugestion-edit.component';

@Component({
  selector: 'content-sugestion',
  imports: [
    MatProgressBar,
    TableListComponent,
    FormSearchComponent,
    MatPaginatorModule,
    MatButton,
  ],
  templateUrl: './content-sugestion.component.html',
  styleUrl: './content-sugestion.component.scss',
  providers: [ContentSugestionService, AuthService],
  standalone: true,
})
export class ContentSugestionComponent implements OnInit {
  constructor(
    private messageService: ContentSugestionService,
    private authService: AuthService,
    private dialog: MatDialog,
    private snackbar: SnackbarCustomService,
  ) {}

  page: number = 1
  rows: number = 10
  numberRows: number = 0
  itemsList: any[] = []
  loading: boolean = false
  searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  inputSearch: string = ''
  columns: any[] = [
    {
      keyColumn: 'id',
      key: 'id',
      description: 'Código',
    },
    {
      keyColumn: 'title',
      key: 'titulo',
      description: 'Título',
    },
    {
      keyColumn: 'subtitulo',
      key: 'subtitulo',
      description: 'Subtítulo',
    },
    {
      keyColumn: 'descricao',
      key: 'descricao',
      description: 'Descrição',
    },
    {
      keyColumn: 'action',
      key: { edit: true, delete: true },
      description: 'Ações',
    },
  ]
  screen: string = 'conteudo'

  ngOnInit() {
    this.checkColumnAction()
    this.getListItems()
  }

  checkColumnAction() {
    let index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        edit: this.checkPermission('editar'),
        delete: this.checkPermission('excluir'),
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  search(event: any) {
    let search = event
    this.page = 1
    if (search) {
      this.searchForm.nome = search
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  pageChanged(page: number) {
    this.page = page
    this.uploadList()
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1 // pageIndex é zero-based, a sua variável page é 1-based
    this.rows = event.pageSize
    this.uploadList()
  }

  pageSizeChanged(newPageSize: number) {
    this.rows = newPageSize
    this.page = 1 // normalmente reseta para a primeira página
    this.uploadList()
  }

  uploadList(type: string = '') {
    if (type == 'new') {
      this.searchForm = new SearchContactTypeModel()
    }
    if (this.searchForm.descricao) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  treatResponse(response: any) {
    let list = []
    if (response.data) {
      for (let item of response.data) {
        list.push(item)
      }
    }
    this.itemsList = list
    this.numberRows = response.paging.total
  }

  // getListItems() {
  //   this.loading = true
  //   this.locationService.listPagedLocation(this.page, this.rows).subscribe({
  //     next: (response: any) => {
  //       this.treatResponse(response)
  //     },
  //     error: (err: PagedContactTypeResponse) => {},
  //     complete: () => {
  //       this.loading = false
  //     },
  //   })
  // }
  getListItems() {
    this.loading = true
    this.messageService.listPagedContentSugestion(this.page, this.rows).subscribe({
      next: (response: any) => {
        this.treatResponse(response)
      },
      error: (err: PagedContactTypeResponse) => {},
      complete: () => {
        this.loading = false
      },
    })
  }

  searchListItems() {
    this.loading = true
    this.messageService
      .searchPagedLocation(this.page, this.rows, this.searchForm)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  newEmployee() {
    const dialogRef = this.dialog.open(ClassificationCreateComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '950px',
      // height: '100vh',
    })
    dialogRef.componentInstance.responseCreate.subscribe((response) => {
      this.uploadList()
    })
  }
  newDriver() {
    const dialogRef = this.dialog.open(ContentSugestionCreateComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '50vw',
      width: '50vw',
      maxHeight: '50vh',
      height: '50vh',
    })
    dialogRef.componentInstance.responseCreate.subscribe((response) => {
      this.uploadList()
    })
  }
  editItem(item: any) {
    const dialogRef = this.dialog.open(ContentSugestionEditComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '50vw',
      width: '50vw',
      maxHeight: '50vh',
      height: '50vh',
      data: {item},
    })
    dialogRef.componentInstance.responseEdit.subscribe((response) => {
      this.uploadList()
    })
  }

  deleteItem(item: any) {
    this.messageService.deleteContentSugestion(item.id).subscribe({
      next: (response: any) => {
        console.log(response.data)
        this.snackbar.success(response.message)
      },
      error: (erro: any) => {
        this.snackbar.error(erro.message)
      },
      complete: () => {
        this.getListItems()
      }
    })
  }
}
